import type { GQL_ID } from '@@partner:types:graphql'
import type { Feedback } from '@@partner:types:app'

import { gql, useMutation } from '@apollo/client'

export interface AddFeedbackCommentMutation {
  addFeedbackComment: Feedback
}

export interface AddFeedbackCommentMutationVariables {
  feedback_id: GQL_ID
  comment: string
}

export const GQL_MUTATION_ADD_FEEDBACK_COMMENT = gql`
  mutation AddFeedbackComment($feedback_id: ID!, $comment: String!) {
    addFeedbackComment(feedback_id: $feedback_id, comment: $comment) {
      id
      brand_id
      shop_id
      order_id
      review
      general_rating
      assemble_rating
      shipping_rating
      product_rating
      manage_comment
      need_call
      images(style: "medium") {
        url
      }
      customer {
        id
        first_name
        last_name
        phone
      }
      order {
        id
        uuid
        status
      }
      brand {
        id
        name
      }
      shop {
        id
        name
        address
      }
    }
  }
`

export const useAddFeedbackComment = () => {
  return useMutation<AddFeedbackCommentMutation, AddFeedbackCommentMutationVariables>(
    GQL_MUTATION_ADD_FEEDBACK_COMMENT
  )
}